import { createFileRoute } from "@tanstack/react-router";

import { buildSeo } from "@/lib/seo";
import { MarketingLayout } from "@/components/marketing/Layout";
import { LegalDocument } from "@/components/legal/LegalDocument";
import { PRIVACY_DE, PRIVACY_EN } from "@/lib/legal/privacy";

export const Route = createFileRoute("/privacy")({
  head: () =>
    buildSeo({
      path: "/privacy",
      title: "Privacy Policy — Reality Twin Network",
      description:
        "Which personal data we process, on which legal basis, who receives it, how long we keep it, and your rights under the Swiss revFADP and the GDPR.",
    }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <MarketingLayout>
      <LegalDocument de={PRIVACY_DE} en={PRIVACY_EN} />
    </MarketingLayout>
  );
}
